<template>
  <div>
    <!-- bradcam_area  -->
    <div class="bradcam_area bradcam_bg_1">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="bradcam_text">
              <h3>App Features</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /bradcam_area  -->

    <!-- about  -->
    <div class="features_area">
      <div class="container">
        <div class="features_main_wrap">
          <div class="row align-items-center">
            <div class="col-xl-5 col-lg-5 col-md-6">
              <div class="features_info2">
                <h3>
                  Features that helps
                  you to find places
                </h3>
                <p>
                  All type of places Tourism, Restaurants, Hospitals, Bank & ATM's, Shops & Malls,
                  Police Stations, Cinema's, Parkings, Gym's & Salon's, Schools & Libraries and much more...
                </p>
                <div class="about_btn">
                  <a class="boxed-btn4" href="#">Download Now</a>
                </div>
              </div>
            </div>
            <div class="col-xl-5 col-lg-5 offset-xl-1 offset-lg-1 col-md-6">
              <div class="about_draw wow fadeInUp" data-wow-duration=".7s" data-wow-delay=".5s">
                <img src="@/assets/img/ilstrator_img/draw.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="features_main_wrap">
          <div class="row align-items-center">
            <div class="col-xl-5 col-lg-5 offset-xl-1 offset-lg-1 col-md-6">
              <div class="about_image wow fadeInLeft" data-wow-duration=".4s" data-wow-delay=".3s">
                <img src="@/assets/img/ilstrator_img/phone.png" alt />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6">
              <div class="features_info">
                <h3 class="wow fadeInUp" data-wow-duration=".5s" data-wow-delay=".3s">
                  Easy Tourism
                  <br />Places Explorer
                </h3>
                <p
                  class="wow fadeInUp"
                  data-wow-duration=".6s"
                  data-wow-delay=".4s"
                >When you are in new city or region and you want to find tourism places.</p>
                <ul>
                  <li
                    class="wow fadeInUp"
                    data-wow-duration=".7s"
                    data-wow-delay=".5s"
                  >Find Places by Type.</li>
                  <li
                    class="wow fadeInUp"
                    data-wow-duration=".8s"
                    data-wow-delay=".6s"
                  >Place Keyword Search.</li>
                  <li
                    class="wow fadeInUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".7s"
                  >Search by Area.</li>
                </ul>

                <div class="about_btn wow fadeInUp" data-wow-duration=".10s" data-wow-delay=".8s">
                  <a class="boxed-btn4" href="#">Download Now</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ about  -->

    <!-- service_area_2  -->
    <div class="service_area_2 plus_margin">
      <div class="container">
        <div class="row align-items-center">
          <div
            class="col-xl-4 col-lg-4 col-md-6 wow fadeInLeft"
            data-wow-duration=".4s"
            data-wow-delay=".5s"
          >
            <div class="man_thumb">
              <img src="@/assets/img/ilstrator_img/man_walk.png" alt />
            </div>
          </div>
          <div class="col-xl-5 offset-xl-1 col-lg-6 col-md-6">
            <div class="mobile_screen wow fadeInRight" data-wow-duration=".8s" data-wow-delay=".5s">
              <img src="@/assets/img/ilstrator_img/mobile_screen.png" alt />
            </div>
          </div>
        </div>
        <div class="service_content_wrap">
          <div class="row">
            <div class="col-lg-4 col-md-4">
              <div class="single_service wow fadeInUp" data-wow-duration=".5s" data-wow-delay=".3s">
                <span>01</span>
                <h3>Download App</h3>
                <p>Download app from Play Store and Install app in you android device. It's absolutely free.</p>
              </div>
            </div>
            <div class="col-lg-4 col-md-4">
              <div class="single_service wow fadeInUp" data-wow-duration=".6s" data-wow-delay=".4s">
                <span>02</span>
                <h3>Nearby Places</h3>
                <p>Nearby Places withing 8 - 12 km radius of your current location appears in Home Screen.</p>
              </div>
            </div>
            <div
              class="col-lg-4 col-md-4 wow fadeInUp"
              data-wow-duration=".7s"
              data-wow-delay=".5s"
            >
              <div class="single_service">
                <span>03</span>
                <h3>Enjoy the app</h3>
                <p>Find your favourite places, Bookmark your favourite places, Direction to your favourite places.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/ service_area_2  -->
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>